import { Feed, getPersonFullName } from '@mntn-dev/ui-components'
import { ActivityTrans } from '../activity-trans.tsx'
import { Link } from '../index.ts'
import type { ActivityDetailsProps } from './types.ts'

export const ProjectFileAdded = ({
  activity: {
    person,
    details: {
      activityType,
      data: { project, file },
    },
  },
  t,
  onNavigate,
  currentUrl,
}: ActivityDetailsProps<'project_file_added'>) =>
  person && (
    <>
      <Feed.Summary>
        <ActivityTrans
          t={t}
          i18nKey={`${activityType}.summary`}
          values={{
            subject: getPersonFullName(person),
            fileName: file.name,
          }}
        />
      </Feed.Summary>
      <Feed.Annotations>
        <Link {...{ target: project, t, onNavigate, currentUrl }} />
      </Feed.Annotations>
    </>
  )
